const metadataSlice = {
    navButtons: {
        builder: true,
        preset: false
    }
}

export default metadataSlice
export { metadataSlice }
